import React from 'react';
import { useState } from "react";

const TextAreaInput = ({
    title = "Content",
    handleSectionContent,
    sectioncontent,
    setSectionContent,
    buttontext="Save"})=> { 
    const [isError,setErrorStatus] = useState(false);
    const checkFormValidation = (event)=>{
      event.preventDefault();
      if(sectioncontent === '') setErrorStatus(true);
      else {
        setErrorStatus(false);
        handleSectionContent(event);
      };
    }
    return (
        <form class="form-row mt-5" onSubmit={checkFormValidation}>
            <div class="col-md-12">
            <label for="content">{title}</label>
              <div className="row">
                <div className="col-md-12">
                  <textarea
                  value={sectioncontent}
                  onChange={(event)=>{setSectionContent(event.target.value)}} 
                  name="" 
                  id="" 
                  cols="30" 
                  rows="5" 
                  className="form-control"
                  />
                  {isError && <p className="alert alert-warning">Please Fill This Field</p>} 
                </div>
              </div>
              <div className="row mt-2">
              <div className="col-md-12">
                  <button type="submit" className="btn btn-sm btn-block btn-success">{buttontext}</button>
                </div>
              </div>
            </div>
          </form>
    );
  }
  
  export default TextAreaInput; 